import { axiosInstance } from "./";

const ADMIN_COMPANY_USERS_PATH = "/company_users";

/** GET /api/admin_portal/v2/company_users — list/search company employees. */
const getAdminCompanyUsers = (params = {}, config = {}) =>
  axiosInstance.get(ADMIN_COMPANY_USERS_PATH, { ...config, params });

/** GET /api/admin_portal/v2/company_users/:id — show one employee. */
const getAdminCompanyUser = (id) =>
  axiosInstance.get(`${ADMIN_COMPANY_USERS_PATH}/${id}`);

/** POST /api/admin_portal/v2/company_users — create & invite an employee. */
const createAdminCompanyUser = (data) =>
  axiosInstance.post(ADMIN_COMPANY_USERS_PATH, data);

/** PATCH /api/admin_portal/v2/company_users/:id — update employee profile. */
const updateAdminCompanyUser = ({ id, data }) =>
  axiosInstance.patch(`${ADMIN_COMPANY_USERS_PATH}/${id}`, data);

/** DELETE /api/admin_portal/v2/company_users/:id — remove an employee. */
const deleteAdminCompanyUser = (id) =>
  axiosInstance.delete(`${ADMIN_COMPANY_USERS_PATH}/${id}`);

export {
  getAdminCompanyUsers,
  getAdminCompanyUser,
  createAdminCompanyUser,
  updateAdminCompanyUser,
  deleteAdminCompanyUser,
};
